import {Directive, ElementRef, HostListener, Input} from '@angular/core';
import {Tooltip} from '../_model/Tooltip';

@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective {

  @Input('appTooltip') tooltip: Tooltip;

  divEle: HTMLElement;

  constructor(private el: ElementRef) {
    if (!this.divEle) {
      this.divEle = document.createElement('div');
      this.divEle.className = 'tooltip tooltip-custom fade';
      const div = document.createElement('div');
      div.className = 'tooltip-inner';
      this.divEle.appendChild(div);
    }
  }

  private position() {
    let offsetTop = this.el.nativeElement.offsetTop;
    let offsetLeft = this.el.nativeElement.offsetLeft;
    let elem = this.el.nativeElement.offsetParent;
    while (elem) {
      offsetTop += elem.offsetTop;
      offsetLeft += elem.offsetLeft;
      elem = elem.offsetParent;
    }
    // scroll height
    return {offsetTop, offsetLeft};
  }

  @HostListener('mouseenter') onMouseEnter() {
    const offsetWidth = this.el.nativeElement.offsetWidth;
    const offsetHeight = this.el.nativeElement.offsetHeight;
    this.divEle.style.display = 'block';
    this.divEle.style.opacity = '1';
    const position = this.position();
    let [x, y] = [0, 0];
    switch (this.tooltip.placement) {
      case 'left':
        x = position.offsetLeft - offsetWidth;
        if (this.tooltip.offset.length > 0) {
          x = x - this.tooltip.offset[0];
        }
        y = position.offsetTop;
        if (this.tooltip.offset.length > 1) {
          y = y  + this.tooltip.offset[1];
        }
        break;
      case 'right':
        x = position.offsetLeft + offsetWidth;
        if (this.tooltip.offset.length > 0) {
          x = x + this.tooltip.offset[0];
        }
        y = position.offsetTop;
        if (this.tooltip.offset.length > 1) {
          y = y  + this.tooltip.offset[1];
        }
        break;
      case 'top':
        x = position.offsetLeft;
        if (this.tooltip.offset.length > 0) {
          x = x + this.tooltip.offset[0];
        }
        y = position.offsetTop - offsetHeight;
        if (this.tooltip.offset.length > 1) {
          y = y - this.tooltip.offset[1];
        }
        break;
      case 'bottom':
        x = position.offsetLeft;
        if (this.tooltip.offset.length > 0) {
          x = x + this.tooltip.offset[0];
        }
        y = position.offsetTop + offsetHeight;
        if (this.tooltip.offset.length > 1) {
          y = y  + this.tooltip.offset[1];
        }
        break;
      default:
        x = position.offsetLeft + offsetWidth;
        if (this.tooltip.offset.length > 0) {
          x = x + this.tooltip.offset[0];
        }
        y = position.offsetTop;
        break;
    }

    this.divEle.style.left = x + 'px';
    this.divEle.style.top = y + 'px';
    let tips = `<div class="tipsLeft">${this.tooltip.tips}</div>`;
    if (this.tooltip.altKey) {
      tips += `<div class="tipsRight">${this.tooltip.altKey}</div>`;
    }
    this.divEle.firstElementChild.innerHTML = tips;
    document.body.appendChild(this.divEle);
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.divEle.remove();
  }
}
